export const THEME_LEVELS = [
  { level: 1, value: "light", labelKey: "themeStageLight" },
  { level: 2, value: "light_dim", labelKey: "themeStageLightDim" },
  { level: 3, value: "neutral", labelKey: "themeStageNeutral" },
  { level: 4, value: "dark_soft", labelKey: "themeStageDarkSoft" },
  { level: 5, value: "dark", labelKey: "themeStageDark" },
];

const THEMES = new Set(THEME_LEVELS.map((row) => row.value));

export function normalizeTheme(value, fallback = "dark") {
  return THEMES.has(value) ? value : fallback;
}

export function themeLevel(value) {
  return THEME_LEVELS.find((row) => row.value === normalizeTheme(value))?.level || 5;
}

export function themeAtLevel(level) {
  return THEME_LEVELS.find((row) => row.level === Number(level))?.value || "dark";
}

export function applyTheme(value) {
  const normalized = normalizeTheme(value);
  document.documentElement.dataset.theme = normalized;
  localStorage.setItem("pc_theme", normalized);
  return normalized;
}
